module.exports = __webpack_public_path__ + "img/4.2a241058.svg";